import { useEffect } from 'react'
import { canLoadMarketingAnalytics } from '@/lib/productAnalytics'

const CLOUDFLARE_ANALYTICS_SCRIPT_ID = 'cloudflare-web-analytics'
const CLOUDFLARE_ANALYTICS_URL =
  'https://static.cloudflareinsights.com/beacon.min.js'

export function CloudflareAnalytics() {
  useEffect(() => {
    const token = import.meta.env.VITE_CLOUDFLARE_ANALYTICS_TOKEN?.trim()

    if (
      !token ||
      typeof document === 'undefined' ||
      !canLoadMarketingAnalytics(window.location.href, document.referrer)
    ) {
      return
    }

    if (document.getElementById(CLOUDFLARE_ANALYTICS_SCRIPT_ID)) {
      return
    }

    const script = document.createElement('script')
    script.id = CLOUDFLARE_ANALYTICS_SCRIPT_ID
    script.src = CLOUDFLARE_ANALYTICS_URL
    script.defer = true
    // This script has no before-send scrubber. Never measure SPA transitions into
    // the host workspace, camera invitation or OAuth callback.
    script.setAttribute('data-cf-beacon', JSON.stringify({ token, spa: false }))

    document.head.appendChild(script)
  }, [])

  return null
}
